<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item >判读信息</el-breadcrumb-item>
      <el-breadcrumb-item>检查阶段</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <el-divider></el-divider> -->
    <header> 
      <h3>客户信息</h3>
    </header>
    <el-form :inline="true" :model="query" class="demo-form-inline" label-position="top">
      <el-row>
        <el-col :span="6">
          <el-form-item label="手机号码">
            <el-input v-model="query.teleNum" placeholder="手机号码"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="姓名">
            <el-input v-model="query.name" placeholder="姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="检测状态">
            <el-select v-model="query.state"  clearable placeholder="请选择检测状态">
              <el-option v-for="(item,index) in stateList" 
                :label="item.label" 
                :value="item.value" 
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" :offset="18">
            <el-form-item>
                <el-upload
                  class="upload-demo"
                  ref="uploadRawStress"
                  accept="application/zip"
                  multiple
                  :limit="50"
                  :action="uploadRawFromOtherPath()"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :file-list="fileList"
                  :auto-upload="false"
                  :on-success="uploadSuccess"
                  :on-error="handleError"
                >
                  <el-button slot="trigger" size="small" type="primary"
                    >选取文件</el-button
                  >
                  <el-button
                    style="margin-left: 10px"
                    size="small"
                    type="success"
                    @click="submitUploadStress($event)"
                    >上传到服务器</el-button
                  >
                </el-upload>
            </el-form-item>
            <el-form-item>
            <el-button type="primary" size="medium" @click="search">查询</el-button>
            <el-button type="primary" size="medium" @click="reset">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- table Loading -->
    <el-table
      v-loading = "pictLoading"
      element-loading-background = "rgba(0, 0, 0, 0.2)"
      element-loading-text = "数据正在加载中"
      element-loading-spinner = "el-icon-loading"
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      fit
      highlight-current-row
      style="width: 100%"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column type="selection" ></el-table-column>
      <el-table-column
        prop="userTeleNum"
        label="手机号码"
      ></el-table-column>
      <el-table-column prop="name" label="姓名" > </el-table-column>
      <el-table-column prop="gender" label="性别" > </el-table-column>
      <el-table-column prop="age" label="年龄" :formatter="ageFormatter"> </el-table-column>
      <el-table-column prop="arrivalTime" label="到达时间" > </el-table-column>
      <el-table-column
        prop="state"
        label="检测状态"
        :formatter="stateFormatter"
      ></el-table-column>
      <el-table-column label="操作" width="250">
        <template slot-scope="scope">
          <el-button size="mini" @click="checking(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="pagination.pageSizeList"
        :page-size="pagination.pageSize"
        :total="pagination.totalNumber"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// import Moment from 'moment'
import { ExamStatesValue ,ExamStatesLabel, unifiedPagination } from "../../../utils/constants"
import { searchUser, cancelBookedResource } from "../../../api/userService";
import { updateExamState } from "../../../api/userExamService";
import { Util_updateExamState } from "../../../utils/util";
import {
  Formatter_examStatesFormatter,
  Formatter_ageFormatter,
} from "../../../utils/formatter";
import { baseURL } from "../../../api/axiosCreator";
export default {
  name: "nurse",
  components: {},
  data() {
    return {
      fileList: [],
      //table Loading
      pictLoading:true,
      //查询字段
      query: {
        teleNum: "",
        name: "",
        // date: "",
        state:"",
      },
      stateRange: {
        fromStat: ExamStatesValue.ARRIVAL_20,
        toStat: ExamStatesValue.HYPERQ_70,
      },
      //检测状态列表
      stateList:[
        {
          value:ExamStatesValue.ARRIVAL_20,
          label:ExamStatesLabel.ARRIVAL_20
        },
        {
          value:ExamStatesValue.BASIC_QUERY_30,
          label:ExamStatesLabel.BASIC_QUERY_30
        },
        {
          value:ExamStatesValue.BASIC_CHECK_40,
          label:ExamStatesLabel.BASIC_CHECK_40
        },
        {
          value:ExamStatesValue.EMC_50,
          label:ExamStatesLabel.EMC_50
        },
        {
          value:ExamStatesValue.ECG_60,
          label:ExamStatesLabel.ECG_60
        },
        {
          value:ExamStatesValue.HYPERQ_70,
          label:ExamStatesLabel.HYPERQ_70
        }
      ],
      //检测人列表
      tableData: [],
      multipleSelection: [],
      pagination: unifiedPagination,
    };
  },
  methods: {
    stateFormatter(row) {
      return Formatter_examStatesFormatter(row.state);
    },
    ageFormatter(row) {
      return Formatter_ageFormatter(row.birthDate);
    },
    _searchUser(){
      //path parameters
      let params = this.pagination.pageNum + '/' + this.pagination.pageSize;
      //body parameters
      let data = {};
      if(this.query.teleNum != ""){
        data.teleNum = this.query.teleNum
      }
      if(this.query.name != ""){
        data.name = this.query.name
      }
      if(this.query.state){
        data.fromStat = this.query.state
        data.toStat = this.query.state;
      }else{
        data.fromStat = this.stateRange.fromStat
        data.toStat = this.stateRange.toStat
      }

      console.log("query",data)

      searchUser( params , data )
      .then(res => {
        if(res.success) {
          //初始化分页
          this.pagination.pageNum = 1
          this.pagination.currentPage = 1
          this.pagination.totalNumber = res.totalNumber
          this.pagination.totalPage = res.totalPage
          this.tableData = res.data;
        }
        else{
          this.$message({ message: res.description, type:"error"})
        }
          setTimeout(this.loadingSuccess,800);
      })
      .catch(e => {
          setTimeout(this.loadingSuccess,800);
        alert(e)
      })
    },
    loadingSuccess(){
      this.pictLoading = false
    },
    print() {},
    search() {
      this._searchUser();
    },
    reset() {
      this.query.teleNum = "";
      this.query.name = "";
       this.query.state = "";
      this._searchUser();
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    submitUploadStress() {
      this.$refs.uploadRawStress.submit();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pagination.pageSize = val;
      this._searchUser();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pagination.pageNum = val;
      this._searchUser();
    },
    //已到达
    HasArrived(row) {
      //如果已到达，则将其状态改为30:基础问询中
      let state = ExamStatesValue.ARRIVAL_20;
      Util_updateExamState(
        row.examUuid,
        state,
        updateExamState,
        this._searchUser,
        this.$message
      );
    },
    CancelBook(row) {
      cancelBookedResource(row.userTeleNum)
        .then((res) => {
          if (res.success) {
            this.$message({ message: res.description, type: "success" });
            this._searchUser();
          } else {
            this.$message({
              message: res.description,
              type: "error",
            });
          }

          if (res.error) {
            this.$message({
              message: res.error,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e,
            type: "error",
          });
        });
    },
    uploadSuccess(res,file) {
      if (res.success) {
        file.status = 'success';
        this._searchUser();
        this.$message({ message: "恭喜你，上传成功", type: "success" });
      } else {
        file.status = 'fail';
        this.$message.error("上传失败，请重新上传");
      }
    },
    handleError(err,file,fileList){
      console.log(err);
      fileList.push(file);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    checking( row ) {
      this.$router.push({path:'/doctor/basicInfo',
        query:{
          teleNum: row.userTeleNum,
          // examUuid:row.examUuid,
          examUuid: row.examUuid,
        }
      })
    },
  },
  computed: {
    uploadRawFromOtherPath() {
      return () => {
        return (
          baseURL +
          "/ExamService/uploadRawFromOther/?token="  + sessionStorage.getItem("logintoken")
        );
      };
    },
  },
  mounted() {
    this._searchUser();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

div.block {
  margin-top: 25px;
}

header {
  margin-top: 30px;
}

/* div.block {
  box-sizing: border-box;
}
._contentContainer {
  box-sizing: border-box;
  height: 563px;
  overflow-y: scroll;
} */
</style>